import { ImgSize } from '@/models/Image'
import { getApp } from 'firebase/app'
import { getDownloadURL, getMetadata, getStorage, list, listAll, ref } from 'firebase/storage'

class FileStorageService {
  private get storage() {
    const app = getApp()
    return getStorage(app)
  }

  async listFiles(subFolder: string): Promise<Array<{ url: string; name: string }>> {
    const storageRef = ref(this.storage, subFolder)
    const files = await list(storageRef)
    return Promise.all(
      files.items.map(async (item) => {
        const meta = await getMetadata(item)
        const url = await getDownloadURL(item)

        return { url, name: meta.name }
      }),
    )
  }

  async getMatchingTempProductImageNames(sku: string) {
    const storageRef = ref(this.storage, `tempProductImages/256`)
    const files = await listAll(storageRef)
    return files.items.filter((item) => item.name.startsWith(sku)).map((item) => item.name)
  }

  async getTempProductImageUrl(fileName: string, size = 256 as ImgSize) {
    try {
      const storageRef = ref(this.storage, `tempProductImages/${size}/${fileName}`)
      return await getDownloadURL(storageRef)
    } catch (err) {
      return undefined
    }
  }

  async getUrl(path: string) {
    try {
      const storageRef = ref(this.storage, path)
      return await getDownloadURL(storageRef)
    } catch (err) {
      return undefined
    }
  }
}
export default new FileStorageService()
